<template>
    <nav class="mb-6">
        <ol class="flex items-center gap-2 text-sm">
            <li>
                <NuxtLink
                    to="/sebapoznanie"
                    class="text-gray-500 hover:text-gray-900 dark:text-txt-body dark:hover:text-white transition-colors"
                >
                    Sebapoznanie
                </NuxtLink>
            </li>
            <li class="text-gray-400 dark:text-txt-body">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </li>
            <li v-if="testName">
                <NuxtLink
                    v-if="testLink"
                    :to="testLink"
                    class="text-gray-500 hover:text-gray-900 dark:text-txt-body dark:hover:text-white transition-colors"
                >
                    {{ testName }}
                </NuxtLink>
                <span v-else class="text-gray-900 dark:text-white font-medium">
                    {{ testName }}
                </span>
            </li>
            <template v-if="currentPage">
                <li class="text-gray-400 dark:text-txt-body">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </li>
                <li class="text-gray-900 dark:text-white font-medium">
                    {{ currentPage }}
                </li>
            </template>
        </ol>
    </nav>
</template>

<script setup lang="ts">
interface Props {
    testName?: string
    testLink?: string
    currentPage?: string
}

defineProps<Props>()
</script>
